import { useNotifications } from '@/components/Notifications/useNotifications';
import {Notification} from './Notification';
import styles from './index.module.scss';

export const Notifications = () => {
    const {notifications} = useNotifications();

    return (
        <div className={styles.notifications}>
            {notifications.map(item => (
                <Notification notification={item} key={item.id} />
            ))}
        </div>
    );
};
